import React, { useState, useEffect } from 'react';
import { string, number } from 'prop-types';
import MultiRef from 'react-multi-ref';

const defaultIcon = require('../../../../static/images/icon_placholder.svg');

const iconRefs = new MultiRef();

const INITIAL_OFFSET = 25;
const circleConfig = {
    viewBox: '0 0 38 38',
    x: '19',
    y: '19',
    radio: '15.91549430918954'
};

const percentage = (percent, total) => ((percent / 100) * total).toFixed(0);

const CircleProgressBarBase = ({
    className,
    strokeColor,
    strokeWidth,
    legendText,
    numberValue,
    speed,
    icon,
    counterId
}) => {
    const [progressBar, setProgressBar] = useState(0);
    const [numberText, setNumberText] = useState();
    const alt = /[^/]*$/.exec(icon || defaultIcon)[0];
    const pace = numberValue / speed;
    const updatePercentage = () => {
        setTimeout(() => {
            if (progressBar >= 80) {
                const iconEl = iconRefs.map.get(counterId);

                if (iconEl) {
                    const arr = iconEl.className.split(' ');

                    if (arr.indexOf('grow') === -1) {
                        iconEl.className += ' ' + 'grow';
                    }
                }
            }

            setProgressBar(progressBar + 1);
            setNumberText(percentage(progressBar, numberValue));
        }, pace);
    };

    useEffect(() => {
        if (numberValue > 0 && progressBar <= 100) {
            updatePercentage();
        }
    }, [numberValue, progressBar, updatePercentage]);

    return (
        <div className={className}>

            <svg viewBox={circleConfig.viewBox}>
                <circle
                    className="donut-segment"
                    cx={circleConfig.x}
                    cy={circleConfig.y}
                    r={circleConfig.radio}
                    fill="transparent"
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    strokeDasharray={`${progressBar} ${100 - progressBar}`}
                    strokeDashoffset={INITIAL_OFFSET}
                />

                <g className="counter-text">
                    <text x="50%" y="50%" className="counter-number">
                        {numberText}
                    </text>
                </g>
            </svg>

            <img
                className="shape-icon"
                src={icon || defaultIcon}
                ref={iconRefs.ref(counterId)}
                alt={alt}
            />


            {legendText && (
                <div className="counter-label">
                    {legendText}
                </div>
            )}
        </div>
    );
};

CircleProgressBarBase.propTypes = {
    className: string.isRequired,
    strokeColor: string,
    strokeWidth: number,
    legendText: string,
    numberValue: number,
    speed: number,
    icon: string,
    counterId: string
};

CircleProgressBarBase.defaultProps = {
    strokeColor: '#ffad00',
    strokeWidth: .5,
    legendText: '',
    speed: 1
};

export default CircleProgressBarBase;
